import React, { useState, useEffect, useContext } from "react";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import service from "../../../../api/services";
import organisms from "../../../../components/organisms";
import { useToasts } from 'react-toast-notifications';
import { HeaderHeading } from "../../../../Context";
import { handleReportDownload } from "../../../../constants/utils"

const { CustomerReport } = organisms
const Index = () => {
    const { setHeader }: any = useContext(HeaderHeading);
    const { addToast } = useToasts();

    useEffect(() => {
        setHeader("Reports - Customer Report")
    }, [])

    const [inventoryReportData, setInventoryReport] = useState({
        report_date: Date,
        report_format: NaN,
    })

    const handleSubmit = async () => {
        try {
            const response = await service.reportService?.customer({ report_date: inventoryReportData?.report_date })
            if (response.status === 200) {
                if (!response?.data?.data) {
                    addToast(response?.data?.message, {
                        appearance: 'error',
                        autoDismiss: true,
                        autoDismissTimeout: 3000,
                    });
                } else {
                    const { report_format } = inventoryReportData || {};
                    handleReportDownload(response?.data?.data, "customer_report", report_format, "");
                }
            }
        } catch (error: any) {
            console.error('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }


    const handleChange = (name: string, value: any) => {
        setInventoryReport({ ...inventoryReportData, [name]: value })
    }


    return (
        <Wrapper>
            <CustomerReport
                handleChange={(name: string, value: any) => handleChange(name, value)}
                handleSubmit={() => handleSubmit()}
                inventoryReportData={inventoryReportData}
            />
        </Wrapper>
    )
}

export default Index